<div class="offline-form-message" ng-show="$ctrl.hasOfflineForm">
    <div class="content" ng-click="$ctrl.complete()">
        <div class="header">{{'offline.form.message'|translate}}</div>
        <div class="message">{{'offline.form.message.description'|translate}}</div>
    </div>
</div>